import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TecFormErrorCardComponent } from './tec-form-error-card.component';
import { MatCardModule } from '@angular/material/card';

@NgModule({
  declarations: [TecFormErrorCardComponent],
  imports: [CommonModule, MatCardModule],
  exports: [TecFormErrorCardComponent],
})
export class FormErrorCardModule {}
